/**
 * SFCC-11931: resolve the shopper-facing callout message for a basket price
 * adjustment. The merchant-authored callout lives on the PROMOTION
 * (ShopperPromotions `calloutMsg` — SFRA's `promotion.calloutMsg.markup`),
 * not on the adjustment: the adjustment's `itemText` is SFCC's lineItemText,
 * which stays the internal promotion ID even when a callout IS configured
 * (verified on bfkw-dev), so it is never used for display. No callout
 * configured → nothing renders. (Base SFRA falls back to a generic
 * "Discount" label per line item here; we deliberately show nothing instead —
 * only merchant-authored copy reaches shoppers.)
 */
export const resolvePromotionCallout = (
  adjustment: { promotionId?: string },
  promotionCallouts: Record<string, string> | undefined,
): string | undefined => {
  return adjustment.promotionId
    ? promotionCallouts?.[adjustment.promotionId]
    : undefined;
};
